import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Footer } from "@/components/Footer";
import { Metodo } from "@/components/Metodo";
import { Proyectos } from "@/components/Proyectos";
import { Servicios } from "@/components/Servicios";
import { PlaceholderSection } from "@/components/PlaceholderSection";
import { SobreGlendaContacto } from "@/components/SobreGlendaContacto";

const ROTATION_VIDEO = "https://customer-assets.emergentagent.com/job_heritage-global-1/artifacts/4v2u90cz_3D_mathematical_structure_rotation_202607082133.mp4";

const SECTIONS = [
  { id: "ecosistema", eyebrow: "Nuestra red viva", title: "Ecosistema" },
  { id: "participa", eyebrow: "Sumate", title: "Participa" },
];

const Landing = () => (
  <div className="min-h-screen bg-[#0A0908] text-white">
    <Navbar />
    <main>
      <Hero />
      <Metodo />
      <Proyectos />
      <Servicios />
      {SECTIONS.length > 0 && (
        <div className="relative overflow-hidden" data-testid="placeholder-video-wrapper">
          <video
            src={ROTATION_VIDEO}
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
            className="absolute inset-0 w-full h-full object-cover opacity-50"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0908] via-black/60 to-[#0A0908] pointer-events-none" />
          <div className="relative z-10">
            {SECTIONS.map((s) => (
              <PlaceholderSection key={s.id} {...s} />
            ))}
            <SobreGlendaContacto />
          </div>
        </div>
      )}
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
